import React, { useState, useEffect } from "react";

function RandumUser() {
  const [allUsers, setAllUsers] = useState([]);
  const [user, setuser] = useState({});
  const [refresh, setRefresh] = useState(true);
  useEffect(() => {
    fetch("https://randomuser.me/api/")
      .then((res) => res.json())
      .then((data) => setuser(data.results[0]));
  }, [refresh]);

  const add = (e) => {
    e.preventDefault();
    setRefresh(!refresh);
    setAllUsers([...allUsers, user]);
  };
  return (
    <>
      <button type="button" onClick={add}>
        Add User
      </button>
      {allUsers.map((eachUser, index) => (
        <div key={index}>
          <img src={eachUser.picture.large} alt="imgae" />
          <h3>
            {eachUser.name.title} {eachUser.name.first} {eachUser.name.last}
          </h3>
        </div>
      ))}
    </>
  );
}

export default RandumUser;
